export const getPaceString = (pace, holesPlayed, carType) => {
    // If not a golfer type of car then just return an empty string
    var result = "";
    if (carType === 1 || carType === 3) {
      //normal or handicap
      if (pace > 0) result = `${pace.toString()} min ahead `;
      else if (pace < 0) result = `${(-pace).toString()} min behind `;
      else result = "on pace ";
      if (holesPlayed > 0)
        result = `${result} through ${holesPlayed.toString()}`;
    }
    return result;
  };